module.exports = __webpack_public_path__ + "img/cart-large-p.eb1b7a9b.svg";